module.exports = __webpack_public_path__ + "static/media/export-csv-example.17aa8491.png";